/*
 * Title: GentleApi Obejct 
 * Author: KimTaeOh (taeoh.kim@gentlepie.com )
 * Date: 2021-04-03
 */

export default {
    type: {
        List: 'List',
        FoundBot: 'FoundBot',// '{name}님, 최근 주문내역을 확인해보세요',
        NotFoundBot: 'NotFoundBot',// '{name}님, 최근 주문내역이 없어요. 애터미쇼핑몰의 인기상품과 신상품을 구경하시겠어요?',
        NotFoundBotNomember: 'NotFoundBotNomember',// '최근 주문내역이 없어요. 애터미쇼핑몰의 인기상품과 신상품을 구경하시겠어요?',
        Other: 'Other',// '다른 주문내역 보기',
        Detail: 'Detail',// '주문내역 자세히 보기',
        DeliveryInfo: 'DeliveryInfo',// '배송정보',
        No: 'No', // 주문번호',
        Date: 'Date', // '판매일자',
        Prd: 'Prd',// '예상 배송일',
        Price: 'Price',// '결제금액',
        TotalPrice: 'TotalPrice',
        Receiver: 'Receiver',// '받으시는 분',
        Addess: 'Addess', // '배송지',
        Message: 'Message',// '배송메시지',
        Payment: 'Payment',// '결제정보',
        PaymentInfo: 'PaymentInfo',// '결재내역',
        Card: 'Card',// '신용카드',        
        SendMoney: 'SendMoney',
        BankInfo: 'BankInfo',
        ListInfo: 'ListInfo',
        DateComment: 'DateComment', // 결제일로부터 3일 이내<br>(주말, 공휴일 제외)
        More: 'More',// '더 많은 주문내역 보기',
        Update: 'Update', // 판매일자 변경하기
        Nomember: 'Nomember', // 아하. 비회원님의 주문내역은 쇼핑몰과 챗봇 모두에서 확인하실 수 있어요. 선택해주시겠어요?
        InWeb: 'InWeb', // 쇼핑몰에서 학인하기
        InChat: 'InChat', // 챗봇에서 확인하기
        InputNomember: 'InputNomember', // 비회원님의 주문내역을 보여드릴게요. 먼저 주문번호와 성함을 입력해주세요.
        InputOrderno: 'InputOrderno', // 주문번호를 입력하세요.
        InputName: 'InputName', // 성함을 입력하세요.
    },
    tomy:{
        kr: {            
            More: '더 많은 주문내역 보기',
            List: '주문내역 보기',
            FoundBot: '{name}님의 최근 주문내역입니다.',
            NotFoundBot: '{name}님, 최근 주문내역이 없으시네요. 필요한 게 있는지 둘러보시겠어요?',
            NotFoundBotNomember: '최근 주문내역이 없으시네요. 필요한 게 있는지 둘러보시겠어요?',
            Other: '다른 주문내역 보기',            
            Detail: '주문내역 자세히 보기',
            DeliveryInfo: '배송정보',
            No: '주문번호',
            Date: '판매일자',
            Prd: '예상 배송일',
            Price: '결제금액',
            TotalPrice: '총 결제금액',
            Receiver: '받으시는 분',
            Addess: '배송지',
            Message: '배송메시지',
            Payment: '결제정보',
            PaymentInfo: '결재내역',
            Card: '신용카드',
            SendMoney: '계좌이체',
            BankInfo: '계좌정보',
            ListInfo: '1년 내 최근 주문내역 5건입니다. 아래 버튼을 누르면 더 많은 주문내역을 볼 수 있습니다.',
            DateComment: '결제일로부터 3일 이내<br>(주말, 공휴일 제외)',
            Update: '판매일자 변경하기', // 
            Nomember: '아하. 비회원님의 주문내역은 쇼핑몰과 챗봇 모두에서 확인하실 수 있어요. 선택해주시겠어요?',
        },
        eng: {
            More: 'View additional orders',
            List: 'View order history',
            FoundBot: '{name}, this is your latest order.',
            NotFoundBot: '{name}, you have no recent orders. Would you like to take a look around to see what you need?',
            NotFoundBotNomember: 'there are no recent orders. Would you like to look around to see if you need anything?',
            Other: 'View other orders',            
            Detail: 'View order details',
            DeliveryInfo: 'Shipping information',
            No: 'Order number',
            Date: 'Sales date',
            Prd: 'Estimated Delivery Date',
            Price: 'Payment price',
            TotalPrice: 'Total price',
            Receiver: 'Recipient',
            Addess: 'Address',
            Message: 'Delivery message',
            Payment: 'Payment info',
            PaymentInfo: 'Payment history',
            Card: 'Credit card',
            SendMoney: 'Account transfer',
            BankInfo: 'Account info',
            ListInfo: '5 recent orders within 1 year. Click the button below to view more order details.',
            DateComment: 'Within 3 days of payment date<br>(Except weekends, holildays)',
            Update: 'Change the sale date', // 
            Nomember: '아하. 비회원님의 주문내역은 쇼핑몰과 챗봇 모두에서 확인하실 수 있어요. 선택해주시겠어요?',
        }
    },
    papa:{
        kr: {
            More: '더 많은 주문내역 보기',
            List: '주문내역 보기',
            FoundBot: '{name}님이 최근 주문한 상품이에요.',
            NotFoundBot: '{name}님, 최근에 주문한 상품이 없네요. 필요한 게 있는지 둘러보겠어요?',
            NotFoundBotNomember: '최근 주문내역이 없으시네요. 필요한 게 있는지 둘러보시겠어요?',
            Other: '다른 주문내역 보기',            
            Detail: '주문내역 자세히 보기',
            DeliveryInfo: '배송정보',
            No: '주문번호',
            Date: '판매일자',
            Prd: '예상 배송일',
            Price: '결제금액',
            TotalPrice: '총 결제금액',
            Receiver: '받으시는 분',
            Addess: '배송지',
            Message: '배송메시지',
            Payment: '결제정보',
            PaymentInfo: '결재내역',
            Card: '신용카드',
            SendMoney: '계좌이체',
            BankInfo: '계좌정보',
            ListInfo: '1년 내 최근 주문내역 5건입니다. 아래 버튼을 누르면 더 많은 주문내역을 볼 수 있습니다.',
            DateComment: '결제일로부터 3일 이내<br>(주말, 공휴일 제외)',
            Update: '판매일자 변경하기', // 
            Nomember: '아하. 비회원님의 주문내역은 쇼핑몰과 챗봇 모두에서 확인하실 수 있어요. 선택해주시겠어요?',
            InWeb: '쇼핑몰에서 확인하기', 
            InChat: '챗봇에서 확인하기',
            InputNomember: '비회원님의 주문내역을 보여드릴게요. 먼저 주문번호와 성함을 입력해주세요.',
            InputOrderno: '주문번호를 입력하세요.', // 
            InputName: '성함을 입력하세요.', // 
        },
        eng: {
            More: 'View additional orders',
            List: 'View order history',
            FoundBot: '{name}, there are no recent orders. Would you like to look around to see if you need anything?',
            NotFoundBot: '{name}, there are no recent orders. Would you like to look around to see if you need anything?',
            NotFoundBotNomember: 'there are no recent orders. Would you like to look around to see if you need anything?',
            Other: 'View other orders',            
            Detail: 'View order details',
            DeliveryInfo: 'Shipping information',
            No: 'Order number',
            Date: 'Sales date',
            Prd: 'Estimated Delivery Date',
            Price: 'Payment price',
            TotalPrice: 'Total price',
            Receiver: 'Recipient',
            Addess: 'Address',
            Message: 'Delivery message',
            Payment: 'Payment info',
            PaymentInfo: 'Payment history',
            Card: 'Credit card',
            SendMoney: 'Account transfer',
            BankInfo: 'Account info',
            ListInfo: '5 recent orders within 1 year. Click the button below to view more order details.',
            DateComment: 'Within 3 days of payment date<br>(Except weekends, holildays)',
            Update: 'Change the sale date', // 
            Nomember: '아하. 비회원님의 주문내역은 쇼핑몰과 챗봇 모두에서 확인하실 수 있어요. 선택해주시겠어요?',
            InWeb: 'InWeb', // 쇼핑몰에서 학인하기
            InChat: 'InChat', // 챗봇에서 확인하기  
            InputNomember: '비회원님의 주문내역을 보여드릴게요. 먼저 주문번호와 성함을 입력해주세요.',  
            InputOrderno: 'InputOrderno', // 주문번호를 입력하세요.
            InputName: 'InputName', // 성함을 입력하세요.    
        }
    },
};
